import { useAppContext } from "../../../../shared/contexts/app-context/components/AppContext";
import { Stack } from "@mui/material";
import { ViewSectionType } from "../../../module-selector/types/ViewSectionType";
import { ViewSection } from "../view-section/ViewSection";

export function ApplicationWorkspace() {
    const {
        leftViewSectionModuleType,
        rightViewSectionModuleType,
        activeViewSection,
        setActiveViewSection
    } = useAppContext();
    
    return (
        <Stack
            direction="row"
            spacing={0}
            sx={{
                display: 'flex',
                flex: 1,
                overflow: 'auto',
            }}
        >
            <ViewSection
                viewSectionType={ViewSectionType.Left}
                activeViewSectionType={activeViewSection}
                activeViewSectionModuleType={leftViewSectionModuleType}
                setActiveViewSection={setActiveViewSection}
            />
            <ViewSection
                viewSectionType={ViewSectionType.Right}
                activeViewSectionType={activeViewSection}
                activeViewSectionModuleType={rightViewSectionModuleType}
                setActiveViewSection={setActiveViewSection}
            />
        </Stack>
    );
}